const Authorization = 'authorization'//接口返回的权限参数
export function getAuthorization(){
  var value = localStorage.getItem(Authorization);
  return value
}

export function setAuthorization(value){
  value = encodeURIComponent(value);
  return localStorage.setItem(Authorization,value)
}